import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, TrendingUp } from "lucide-react";

export default function MarketBenchmarksPage() {
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-testid="benchmarks-page">
      <div className="tracking-overline mb-3">Resources · Coming soon</div>
      <h1 className="font-serif text-4xl md:text-5xl text-[#11211A] tracking-tight leading-tight">
        Market Benchmarks
      </h1>
      <p className="text-lg text-[#4A5550] mt-6 leading-relaxed max-w-2xl">
        Real, anonymised pricing and lead-time benchmarks pulled directly from RFQs submitted through the marketplace.
        Know if your quote is above, at, or below market — before you sign a contract.
      </p>

      <div className="mt-14 grid md:grid-cols-2 gap-4">
        {[
          { t: "Bath towel benchmarks",         b: "Median $/unit by GSM, by country of origin, updated monthly." },
          { t: "Sheet set benchmarks",          b: "Percale vs sateen, TC bands 200/300/400/1000 — the honest price floor." },
          { t: "Lead time reality check",       b: "How long real orders actually take from PO to delivered pallet." },
          { t: "MOQ elasticity",                b: "What suppliers accept below their published MOQ — with data." },
        ].map((c) => (
          <div key={c.t} className="border border-[#E8ECE9] p-6" data-testid="benchmark-chapter">
            <TrendingUp className="w-5 h-5 text-[#B35C4A] mb-3" />
            <div className="font-medium text-lg text-[#11211A] mb-1">{c.t}</div>
            <p className="text-sm text-[#4A5550] leading-relaxed">{c.b}</p>
          </div>
        ))}
      </div>

      <div className="mt-14 border border-[#264839]/20 bg-[#F0EFEA] p-8">
        <div className="flex items-start gap-4 flex-wrap">
          <div className="flex-1 min-w-[240px]">
            <div className="font-serif text-2xl text-[#11211A]">Get the first benchmark report free.</div>
            <p className="text-sm text-[#4A5550] mt-2 leading-relaxed max-w-lg">
              Sign up for The Procurement Brief on the homepage and you'll receive the first Market Benchmark
              report as soon as we've gathered enough RFQ data to publish it.
            </p>
          </div>
          <Link to="/#notify" className="btn-primary shrink-0" data-testid="benchmarks-cta">
            Subscribe <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </div>
    </div>
  );
}
